import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Env, Projects } from '@usimweb/core/models';
import { ColorInjector } from '../ColorInjector';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'usimweb-project-stepper',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './project-stepper.component.html',
    styleUrls: ['./project-stepper.component.scss'],
    standalone: false
})
export class ProjectStepperComponent extends ColorInjector implements OnInit {
  @Output() clickEvent: EventEmitter<Projects> = new EventEmitter<Projects>();

  public project: Projects = { name: '', description: '', is_draft: false } as Projects;

  public firstFormGroup!: UntypedFormGroup;

  public error_name: boolean = false;
  public error_description: boolean = false;

  constructor(
    @Inject('environment') environment: Env,
    private _formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar
  ) {
    super(environment);
  }

  ngOnInit(): void {
    this.initStepper();
    this.changeSomeVar(this.environment.mainColor);
  }

  private initStepper(): void {
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required],
    });
  }

  public create() {
    if (!this.error_name && !this.error_description) {
      this.clickEvent.emit(this.project);
    } else {
      this.snackBar.open('Please only insert allowed characters', 'OK', { duration: 5000 });
    }
  }

  public changeSomeVar(value: string): void {
    document.documentElement.style.setProperty('--stepper-color', value);
  }

  public nameValidator(event: any) {
    const value = event.target.value;
    if (value && value.match(/[A-Za-z\d_\- .!$@£€*?&]/g).length < value.length) {
      this.error_name = true;
    } else {
      this.error_name = false;
    }
  }

  public descriptionValidator(event: any) {
    const value = event.target.value;
    if (value && value.match(/[A-Za-z\d_\- .!$@£€*?&]/g).length < value.length) {
      this.error_description = true;
    } else {
      this.error_description = false;
    }
  }
}
